import OfferApi from "api/offer/offerApi";
import * as eventTypes from "../../eventTypes";
import * as types from "../../actionTypes";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "../httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function computeOfferNextStatesList(documentId, siteId) {
  return async (dispatch, getState) => {
    let nextStates = getState().currentOffer.nextStates;
    if (nextStates.isLoaded) {
      return;
    }

    try {
      await dispatch(
        sendHttpCommandAndWaitForEvent(
          OfferApi.computeOfferNextStatesList(documentId, siteId),
          "ComputeOfferNextStatesListInProgress",
          [eventTypes.OFFER_NEXT_STATES_LIST_COMPUTED],
          false
        )
      );
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateOfferState(documentId, siteId, stateId, comment, reasonsIds) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          OfferApi.updateOfferState(documentId, siteId, stateId, comment, reasonsIds),
          "UpdateOfferStateInProgress",
          [eventTypes.OFFER_STATE_UPDATED]
        )
      );
      if (!event.ok)
        dispatch({ type: types.RESET_NEXT_STATE_FOLDER_LIST });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      dispatch({ type: types.RESET_NEXT_STATE_FOLDER_LIST });
      throw error;
    }
  };
}

export function getCommentsConfig(documentTypeId) {
  return async (dispatch, getState) => {
    let { commentsConfig } = getState().dictionaries;
    if (commentsConfig.isLoaded) return;
    try {
      commentsConfig = await dispatch(sendHttpRequest(OfferApi.getCommentsConfig(documentTypeId)));
      dispatch({ type: types.LOAD_COMMENTS_CONFIG, payload: commentsConfig });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function getFolderList(documentId, siteId, stateId) {
  return async (dispatch, getState) => {
    let folderList = getState().currentOffer.header.folderList;
    if (folderList) {
      return;
    }
    try {
      await dispatch(
        sendHttpCommandAndWaitForEvent(
          OfferApi.getFolderList(documentId, siteId, stateId),
          "ComputeFolderListInProgress",
          [eventTypes.FOLDER_LIST_COMPUTE_FINISHED],
          false
        )
      );
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function resetFolderList() {
  return async (dispatch) => {
    dispatch({ type: types.RESET_NEXT_STATE_FOLDER_LIST });
  };
}